import { render, staticRenderFns } from "./OrderRegionView.vue?vue&type=template&id=d637e378&scoped=true"
import script from "./OrderRegionView.vue?vue&type=script&lang=js"
export * from "./OrderRegionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d637e378",
  null
  
)

export default component.exports